// Sezon değeri, eğitim yılının BİTİŞ yılını temsil eder (örn. 2026-2027 eğitim yılı -> sezon 2027).
// Haziran ayı sonuna kadar mevcut eğitim yılı aktif kabul edilir; Temmuz'dan itibaren bir sonraki
// eğitim yılı (mevcut takvim yılı + 1) aktif sezon olarak kabul edilir.
export const getCurrentSezon = (): number => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0 = Ocak, 6 = Temmuz

    return month >= 6 ? year + 1 : year;
};

// Geçmiş 2, mevcut ve gelecek 1 sezonu listeler (toplam 4 seçenek).
export const getSezonOptions = (): number[] => {
    const current = getCurrentSezon();

    return [current - 2, current - 1, current, current + 1];
};
